import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
  Chip,
  Popover,
  Typography,
  Link,
  TableCell,
  Box,
  CircularProgress,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CasesInformational from 'assets/CasesInformational';
import { t } from 'i18next';
import CasesEmergeny from 'assets/CasesEmergeny';
import CasesHigh from 'assets/CasesHigh';
import CasesLow from 'assets/CasesLow';
import CasesMedium from 'assets/CasesMedium';
import { CriticatilityCellDiv } from 'core/components/global/tables/datagrid/dataGrid.styled';
import { setSideModal } from "modules/flywheel/store/incident";
import { useAppDispatch } from 'core/store/reduxStore';
import { fetchAIAnalysisData } from 'modules/flywheel/services/incidentService';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';

import ReactMarkdown from 'react-markdown';
import remarkGfm from "remark-gfm";


interface SeverityPopoverCellProps {
  value: string;
  key: string;
  findingName: string;
  findingId?: string;
  index: number;
}

export default function SeverityPopoverCell({ value, key, findingName, findingId, index }: SeverityPopoverCellProps) {
    
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [severity, setSeverity] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [analysisContent, setAnalysisContent] = useState<string | string[]>('');
  const hasLoadedRef = useRef(false);
  const dispatch = useAppDispatch();
  
  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    setAnchorEl(event.currentTarget);
    // No need to call getSeverity() here - already loaded on mount
  };

  const handleDelayedClose = () => {
    closeTimerRef.current = setTimeout(() => {
      setAnchorEl(null);
    }, 250); // short delay to allow hover into Popover
  };

  const open = Boolean(anchorEl);
  const renderCriticatilityCell = (
          value: string,
          key: string,
          index: number,
          
      ) => {
          let icon;
          switch (value) {
          case t("SEVERITY.INFORMATIVE"):
              icon = <CasesInformational />;
              break;
          case t("SEVERITY.OTHER"):
              icon = <CasesInformational />;
              break;
          case t("SEVERITY.LOW"):
              icon = <CasesLow />;
              break;
          case t("SEVERITY.MEDIUM"):
              icon = <CasesMedium />;
              break;
          case t("SEVERITY.HIGH"):
              icon = <CasesHigh />;
              break;
          case t("SEVERITY.CRITICAL"):
              icon = <CasesEmergeny />;
              break;
          case t("SEVERITY.FATAL"):
              icon = <CasesEmergeny />;
              break;
          }
          return (
              <TableCell key={`${key}_${index}`} tabIndex={0} onMouseEnter={handleOpen}  onMouseLeave={handleDelayedClose} sx={{
    borderBottom: "none", 
  }}>
                 
                  <CriticatilityCellDiv>{icon} {value}</CriticatilityCellDiv>   
                 
              </TableCell>
          );
      };
const handleViewReport = () => {
    setOpenDialog(true);
    setAnchorEl(null); // Close the popover
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  return (
      <>
        {renderCriticatilityCell(value,key,index)}
      <Dialog 
        open={openDialog} 
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Analysis Report for {findingName}
        </DialogTitle>
        <DialogContent dividers>
         <div className="prose max-w-none whitespace-pre-wrap">
         <ReactMarkdown
        children={
          Array.isArray(analysisContent)
            ? analysisContent.join('').replace(/\\n/g, '\n')
            : (typeof analysisContent === 'string' ? analysisContent.replace(/\\n/g, '\n') : '')
        }
        remarkPlugins={[remarkGfm]}
        
      />
      </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
    
  );
}
